import { MeilisearchFlushTool } from "@/app/Meilisearch/Components/MeilisearchFlushTool";
import { QRCodeTool } from "@/app/Tools/Components/QRCodeTool";
import { ZoomPhoneUsersTool } from "@/app/Settings/Admin/ZoomPhone/Components/ZoomPhoneUsersTool";

export function ToolsScreen() {
  return (
    <>
      <ZoomPhoneUsersTool />
      <QRCodeTool />
      <MeilisearchFlushTool />
    </>
  );
}
